import { captureException } from "@/plugins/sentry";
import { ComponentPublicInstance } from "vue";

export const errorHandler = (
  err: unknown,
  vue: ComponentPublicInstance | null,
  info: string
) => {
  captureException(err as Error);
};

window.addEventListener("error", event => {
  captureException(event.error);
});

window.addEventListener("unhandledrejection", event => {
  captureException(event.reason);
});
